import { css } from '@emotion/css';
import { Flex } from 'antd';
import type React from 'react';
import type { ReactNode } from 'react';
import { ParamCompilationBanner } from './ParamCompilationBanner.tsx';
import { SystemStatusBanner } from './SystemStatusBanner.tsx';

export const SystemStatusWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Flex
      className={css`
        height: 100%;
      `}
      vertical
    >
      <SystemStatusBanner />
      <ParamCompilationBanner />
      <div
        className={css`
          flex-grow: 1;
          overflow-y: auto;
        `}
      >
        {children}
      </div>
    </Flex>
  );
};
